import { Outlet } from "react-router-dom";
import Navbar from "./components/static/Navbar";
import Header from "./components/static/Header";
import classes from "./index.module.css";
import { Button } from "@mantine/core";

export default function General() {
  return (
    <div className={classes.generalContainer}>
      <div className={classes.wrapper}>
        <Outlet />
      </div>
      <Navbar />
    </div>
  );
}
